import { VariantType } from 'notistack';

import { KBAR_BACKGROUND_COLOR } from './customSnackbars/styles';
import { HexColor } from './customSnackbars/DynamicSnackBar/types';

export const SNACKBAR_AUTO_HIDE_DURATION_MS = 5000;

export const NTF_COLOR: { [K in VariantType]: HexColor } = {
  success: '#43a047',
  error: '#f44336',
  info: '#2196f3',
  warning: '#ff9800',
  default: '#2c2c2c',
  kBarSnackBar: KBAR_BACKGROUND_COLOR,
  dynamic: '#2196f3',
} as const;

export const INITIAL_BUTTON_COLOR = '#ffffff';
